<template>

  <popover-box ref="popover" :parent="parent" :direction="direction">
    <single-stepper-range :attribute="attribute" @select="selectAttribute"></single-stepper-range>
  </popover-box>

</template>

<script>
import SingleStepperRange from './SingleStepperRange.vue'
import PopoverBox from './PopoverBox'
import popoverContainerMixin from './popoverContainerMixin'

export default {
  mixins: [
    popoverContainerMixin
  ],
  components: {
    PopoverBox,
    SingleStepperRange
  },
  props: {
    attribute: Object
  },
  methods: {
    selectAttribute (value) {
      this.$refs.popover.dismiss()
      this.$emit('select', value)
    }
  }
}

</script>



// WEBPACK FOOTER //
// SingleStepperPopover.vue?450814e6